const refreshSlot = ({ slot }) => {
  window.googletag.pubads().refresh([slot]);
};

export default refreshSlot;
